import axios from 'axios';
import envService from "@/services/env.service";

const OAUTH2_LOGIN_BASE_URL = envService.getOAuth2LoginBaseUrl();

export const EVENT_LOGIN_CHANGED = "login-changed";

export default {
    providerLogin(provider, code, state) {
        return axios.get(OAUTH2_LOGIN_BASE_URL + '/' + provider, {params: {code: code, state: state}});
    }
}
